export const pluralize = (n: number, w: string): string => (n === 1 ? w : `${w}s`);
